import { Client } from '../common';
import { fromDiagnosticPackageActionsResult, fromDiagnosticPackagesResult } from './dto';

export async function retrieveDiagnosticPackage(payload, options = {}) {
  return await Client.request({
    method: 'POST',
    url: 'device-log-service/diagpackage',
    body: payload,
    ...options
  });
}

export async function searchDiagnosticPackages(payload, options = {}) {
  const result = await Client.request({
    method: 'POST',
    url: 'device-log-service/diagpackage/_search',
    body: payload,
    ...options
  });

  return fromDiagnosticPackagesResult(result);
}

export async function searchDiagnosticPackageActions(payload, options = {}) {
  const result = await Client.request({
    method: 'POST',
    url: 'device-log-service/diagpackage/action/_search',
    body: payload,
    ...options
  });

  return fromDiagnosticPackageActionsResult(result);
}

export async function getDiagnosticPackageAction({ diagPkgId }, options = {}) {
  return await Client.request({
    method: 'GET',
    url: `device-log-service/diagpackage/action/status/${diagPkgId}`,
    ...options
  });
}

export async function getDiagnosticPackageUrl({ deviceId, diagPkgId, isDecrypted }, options = {}) {
  return await Client.request({
    method: 'GET',
    url: `device-log-service/diagpackage/device/${deviceId}/${diagPkgId}?isDecrypted=${isDecrypted}`,
    ...options
  });
}
